import React from 'react';
import { ObservedItem } from './ObservedItem';
import './Styles/Timeline.css';

export class Timeline extends React.Component {
  constructor(props) {
    super(props);
    this.containerStyles = [
      'Timeline__Container--Left',
      'Timeline__Container--Right'
    ];
    this.itemStyle = ['Timeline__Item--Left', 'Timeline__Item--Right'];
  }

  render() {
    const timeline = (
      <div className="Timeline">{this.props.items.map(this.renderItem)}</div>
    );
    return timeline;
  }

  renderItem = (item, index) => {
    let contClass = 'Timeline__Container ';
    contClass += this.containerStyles[index % this.containerStyles.length];
    let itemClass = 'Timeline__Item ';
    itemClass += this.itemStyle[index % this.itemStyle.length];
    return (
      <ObservedItem
        key={index}
        contClass={contClass}
        itemClass={itemClass}
        handleIntersection={this.handleIntersection}
        intersectionOptions={{ threshold: 0.55 }}
      >
        {this.props.renderItem(item)}
      </ObservedItem>
    );
  };

  handleIntersection = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('slideIn');
        if (entry.target.firstChild) {
          entry.target.firstChild.classList.add('slideIn');
        }
      }
    });
  };
}
